// Aurora Innovation, Inc. Proprietary and Confidential. Copyright 2026.
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { iconButtonClasses } from '@mui/material/IconButton';
import { inputBaseClasses } from '@mui/material/InputBase';
import { svgIconClasses } from '@mui/material/SvgIcon';
import { tabClasses } from '@mui/material/Tab';
import { toolbarClasses } from '@mui/material/Toolbar';
import { rem } from '../../tokens/conversions';
import { borderRadius, spacing } from '../../tokens/spacing';
import { condensedTabStyle } from '../Tab/Tab';
import { appBarColors } from './appBarColors';
export var AppBar = function(mode) {
    var c = appBarColors(mode);
    var _obj, _obj1, _obj2;
    var override = {
        MuiAppBar: {
            styleOverrides: {
                root: (_obj1 = {
                    boxShadow: '0px 1px 4px rgba(0, 0, 0, 0.2)',
                    height: rem(60),
                    borderBottom: "".concat(rem(1), " solid ").concat(c.border)
                }, _define_property(_obj1, "& .".concat(toolbarClasses.root), {
                    flexGrow: 1,
                    minHeight: 0,
                    // Figma splits this into two gaps: spacing/5 (24px) between the Logo/Tabs/
                    // SearchBar cluster, and spacing/4 (16px) between that cluster and the
                    // trailing IconButtons/Avatar. A single Toolbar gap can't express both, so
                    // this sets the outer (16px) gap; consumers wrap the leading cluster in its
                    // own flex row with gap: rem(spacing[5]) for the inner 24px gap.
                    gap: rem(spacing[4]),
                    paddingLeft: rem(spacing[3]),
                    paddingRight: rem(spacing[2]),
                    paddingTop: rem(spacing[1]),
                    paddingBottom: rem(spacing[1])
                }), // Corner radius for this search field comes from TextField's own round
                // corner-shape variant (rem(32), matching Figma's Input Box spec) — not
                // duplicated here. Consumers must pass
                // `InputProps={{ 'data-corner-shape': 'round' }}` on the search TextField.
                _define_property(_obj1, "&& .".concat(inputBaseClasses.root), _define_property({}, "& .".concat(svgIconClasses.root), {
                    fontSize: rem(20),
                    padding: rem(spacing[0]),
                    '&:hover': {
                        backgroundColor: 'transparent'
                    }
                })), _define_property(_obj1, "& .".concat(iconButtonClasses.root), (_obj = {
                    borderRadius: rem(borderRadius.default)
                }, _define_property(_obj, ".".concat(svgIconClasses.root), {
                    fill: c.navItem.text,
                    fontSize: rem(20),
                    padding: rem(spacing[0])
                }), _define_property(_obj, '&:hover', {
                    backgroundColor: c.navItem.hover.background
                }), _define_property(_obj, '&[aria-current="page"]', _define_property({}, ".".concat(svgIconClasses.root), {
                    fill: c.navItem.active.text
                })), _obj)), _obj1),
                colorPrimary: {
                    backgroundColor: c.background,
                    color: c.text
                }
            },
            variants: [
                {
                    props: {
                        condensed: true
                    },
                    style: (_obj2 = {
                        // Emergent from Figma, not a fixed spec value: icon buttons stay 36px in
                        // condensed mode, so height = py (spacing/1, 4px) * 2 + 36px = 44px.
                        height: rem(44)
                    }, _define_property(_obj2, "& .".concat(tabClasses.root), condensedTabStyle), // Figma's condensed search field uses a 12px icon; this out-ranks the
                    // 20px root rule above by source order at equal specificity.
                    _define_property(_obj2, "&& .".concat(inputBaseClasses.root), _define_property({}, "& .".concat(svgIconClasses.root), {
                        fontSize: rem(12)
                    })), _obj2)
                },
                {
                    props: {
                        elevation: 0
                    },
                    style: {
                        boxShadow: 'none'
                    }
                }
            ],
            defaultProps: {
                color: 'primary'
            }
        }
    };
    return override;
};

//# sourceMappingURL=AppBar.js.map